import CompanyLayout from "@/layouts/company/app/CompanyLayout";

import dashboard from "./dashboard"
import contacts from "./contacts"
import meetings from "./meetings"
import settings from "./settings"
import team from "./team"
import profile from "./profile"
import documents from "./documents"
import products from "./products"
import services from "./services"

export default [
  

  {
    path: "/company",
    component: CompanyLayout,
    meta: {
      middleware: ["auth", "company"],
      roles: ["exhibitor"],
    },
    children: [
        ...dashboard,
        ...contacts,
        ...meetings,
        ...settings,
        ...team,
        ...profile,
        ...documents,
        ...products,
        ...services,
    ],
  },
];
